export default __webpack_public_path__ + "static/successImage1-1be25c6dc6d771b1ef78fc90edf63ed1.png";